import constants from 'common/constants'

import {
  ADD_USER_CHILDREN,
  ADD_USER_EXPERIENCES,
  ADD_USER_QUALIFICATIONS,
  CHANGE_SCHOOL_USER_PASSWORD,
  EDIT_SCHOOL_USER_PROFILE,
  GET_ALL_STAFF,
  GET_ALL_USERS,
  GET_INACTIVE_USERS,
  GET_INSTITUTE_INFO,
  GET_USER_BANK_INFO,
  GET_USER_CHILDREN,
  GET_USER_EXPERIENCES,
  GET_USER_QUALIFICATIONS,
  SEND_INACTIVE_USER_SMS,
  UPDATE_INSTITUTE_INFO,
  UPDATE_USER_BANK_INFO,
} from './ActionTypes/ApiActionTypes'
import {REDUX_SAVE_SCHOOL_USER_PROFILE} from './ActionTypes/ReduxActionTypes'

export const getUsers = (data, onSuccess, onFailure) => {
  return {
    type: GET_ALL_USERS,
    payload: {
      apiUrl: 'user',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getInactiveUsers = (data, onSuccess, onFailure) => {
  return {
    type: GET_INACTIVE_USERS,
    payload: {
      apiUrl: 'user/inactive',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getInactiveStudents = (data, onSuccess, onFailure) => {
  return {
    type: GET_INACTIVE_USERS,
    payload: {
      apiUrl: 'user/inactive/students',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getInactiveParents = (data, onSuccess, onFailure) => {
  return {
    type: GET_INACTIVE_USERS,
    payload: {
      apiUrl: 'user/inactive/parents',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getInactiveStaff = (data, onSuccess, onFailure) => {
  return {
    type: GET_INACTIVE_USERS,
    payload: {
      apiUrl: 'user/inactive/staff',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getInactiveTeachers = (data, onSuccess, onFailure) => {
  return {
    type: GET_INACTIVE_USERS,
    payload: {
      apiUrl: 'user/inactive/teachers',
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

/**
 * Update school user's profile info
 * @param {{username: string, email: string, firstName: string, lastName: string, gender: number, dob, string, address: string, phone: string, cnic: string, mobile}} profile
 * @param {function(response)} onSuccess
 * @param {function(response)} onFailure
 * @returns
 */
export const editSchoolUserProfile = (profile, onSuccess, onFailure) => {
  return {
    type: EDIT_SCHOOL_USER_PROFILE,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_edit_school_user_profile,
      noAccessToken: false,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: profile,
      reduxActionType: REDUX_SAVE_SCHOOL_USER_PROFILE,
    },
  }
}

/**
 * Update school user's password
 * @param {string} oldPassword
 * @param {string} newPassword
 * @param {function(response)} onSuccess
 * @param {function(response)} onFailure
 * @returns
 */
export const changeUserPassword = (oldPassword, newPassword, onSuccess, onFailure) => {
  return {
    type: CHANGE_SCHOOL_USER_PASSWORD,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_change_school_user_password,
      noAccessToken: false,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: {oldPassword, newPassword},
      reduxActionType: '',
    },
  }
}

/**
 * Get school user's qualifications record
 * @param {function(response)} onSuccess
 * @param {function(response)} onFailure
 * @returns
 */
export const getUserQualifications = (onSuccess, onFailure) => {
  return {
    type: GET_USER_QUALIFICATIONS,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_get_user_qualifications,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

/**
 * Add school user's qualifications record
 * @param {[{degree: string, institute: string, from: string, to: string}]} qualifications
 * @param {function(response)} onSuccess
 * @param {function(response)} onFailure
 * @returns
 */
export const addUserQualifications = (qualifications, onSuccess, onFailure) => {
  return {
    type: ADD_USER_QUALIFICATIONS,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_add_user_qualifications,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: {qualifications},
      reduxActionType: '',
    },
  }
}

/**
 * Get school user's experiences record
 * @param {function(response)} onSuccess
 * @param {function(response)} onFailure
 * @returns
 */
export const getUserExperiences = (onSuccess, onFailure) => {
  return {
    type: GET_USER_EXPERIENCES,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_get_user_experiences,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

/**
 * Add school user's experiences record
 * @param {[{degree: string, institute: string, from: string, to: string}]} experiences
 * @param {function(response)} onSuccess
 * @param {function(response)} onFailure
 * @returns
 */
export const addUserExperiences = (experiences, onSuccess, onFailure) => {
  return {
    type: ADD_USER_EXPERIENCES,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_add_user_experiences,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: {experiences},
      reduxActionType: '',
    },
  }
}

/**
 * Get school user's children record
 * @param {function(response)} onSuccess
 * @param {function(response)} onFailure
 * @returns
 */
export const getUserChildren = (onSuccess, onFailure) => {
  return {
    type: GET_USER_CHILDREN,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_get_user_children,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

/**
 * Add school user's experiences record
 * @param {[{degree: string, institute: string, from: string, to: string}]} children
 * @param {function(response)} onSuccess
 * @param {function(response)} onFailure
 * @returns
 */
export const addUserChildren = (children, onSuccess, onFailure) => {
  return {
    type: ADD_USER_CHILDREN,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_add_user_children,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: {children},
      reduxActionType: '',
    },
  }
}

/**
 * Get school user's bank info
 * @param {function(response)} onSuccess
 * @param {function(response)} onFailure
 * @returns
 */
export const getUserBankInfo = (onSuccess, onFailure) => {
  return {
    type: GET_USER_BANK_INFO,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_get_user_bank_info,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
    },
  }
}

/**
 * Update school user's bankInfo
 * @param {[{bankName: string, accountNo: string, accountTitle: string, branchCode: string, branchAddress: string}]} bankInfo
 * @param {function(response)} onSuccess
 * @param {function(response)} onFailure
 * @returns
 */
export const updateUserBankInfo = (bankInfo, onSuccess, onFailure) => {
  return {
    type: UPDATE_USER_BANK_INFO,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_update_user_bank_info,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: {...bankInfo},
      reduxActionType: '',
    },
  }
}

/**
 * Get all staff of school
 * @param {*} data
 * @param {(response: any) => void} onSuccess
 * @param {(err: any) => void} onFailure
 * @returns
 */
export const getAllSchoolStaff = (data, onSuccess, onFailure) => {
  return {
    type: GET_ALL_STAFF,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_get_all_staff,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
    },
  }
}

/**
 * Get one staff of school
 * @param {string} id
 * @param {(response: any) => void} onSuccess
 * @param {(err: any) => void} onFailure
 * @returns
 */
export const getOneSchoolStaff = (id, onSuccess, onFailure) => {
  return {
    type: GET_ALL_STAFF,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: constants.api_get_one_staff(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      body: id,
      reduxActionType: '',
    },
  }
}

export const sendInactiveUserSms = (body, onSuccess, onFailure) => ({
  type: SEND_INACTIVE_USER_SMS,
  payload: {
    onSuccess,
    onFailure,
    apiUrl: 'user/inactive-sms',
    getString: '',
    useBaseURL: true,
    requestType: 'POST',
    header: 'application/json',
    body,
    reduxActionType: '',
  },
})

export const getInstituteInfo = (onSuccess, onFailure) => ({
  type: GET_INSTITUTE_INFO,
  payload: {
    onSuccess,
    onFailure,
    apiUrl: constants.api_get_institute_info,
    getString: '',
    useBaseURL: true,
    requestType: 'GET',
    header: 'application/json',
    reduxActionType: '',
  },
})

export const updateInstituteInfo = (body, onSuccess, onFailure) => ({
  type: UPDATE_INSTITUTE_INFO,
  payload: {
    onSuccess,
    onFailure,
    apiUrl: constants.api_update_institute_info,
    getString: '',
    useBaseURL: true,
    requestType: 'PUT',
    header: 'application/json',
    body,
    reduxActionType: '',
  },
})
